import { render } from "./blue-tips-icon.vue?vue&type=template&id=b43d51f2&scoped=true&ts=true"
import script from "./blue-tips-icon.vue?vue&type=script&lang=ts"
export * from "./blue-tips-icon.vue?vue&type=script&lang=ts"

import "./blue-tips-icon.vue?vue&type=style&index=0&id=b43d51f2&scoped=true&lang=css"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b43d51f2"]])

export default __exports__